import React, { useState, useEffect } from "react";
import moment from 'moment'
import { useTranslation } from 'react-i18next';
import Files from "../foldersComponent/files";

const SearchResults = ({ searchTerm, files, getFolders, onBack }) => {
  const { t } = useTranslation();

  const [results, setResults] = useState([])

  useEffect(() => {
    const formatted = []
    const dateMap = {}
    if (files) {
      files.forEach(file => {
        const key = file.folder.substr(0, 7)
        file.year = file.folder.substr(0, 4)
        file.month = file.folder.substr(5, 2)
        let dateArray = dateMap[key]
        if (!dateArray) {
          dateArray = []
          dateMap[key] = dateArray
          formatted.push(dateArray)
        }
        dateArray.push(file)
      })
    }

    setResults(formatted)
  }, [files])

  return (
    <div className="map-more-files">
      <div className="search-back-button">
        <button type="submit" className="btn btn-white" onClick={onBack}><i className="fa fa-angle-double-left" aria-hidden="true"></i>{t('search.back')}</button>
      </div>
      <h4 className="h4-title">{t('search.title')}<strong>{searchTerm}</strong></h4>
      {results.length > 0 ?
        results.map((fileList, idx) => <div key={"month-wrapper-"+idx}>
          <ul className="month-box" key={"month-box-"+idx}>
            <li key={"month-label-"+idx} onClick={() => { getFolders(fileList[0].year, moment(fileList[0].updated).format("MMM"), idx) }}>
              <span className="month-link"> {fileList[0].folder.substr(0, 7)}</span>
            </li>
          </ul>
          <Files list={fileList} />
        </div>)

        : <h4 className="h4-title">{t('search.nothing')}</h4>}
    </div>
  )

}
export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/foldersComponent/searchResults.js